import { Drawer, styled, Typography } from '@mui/material';
import { SupplierForm } from '@features/suppliers/components/forms/SupplierForm/SupplierForm';

interface CreateSupplierDrawerProps {
  open: boolean;
  onClose: () => void;
  onSupplierCreated?: (supplierId: string) => void;
}

export const CreateSupplierDrawer = ({
  open,
  onClose,
  onSupplierCreated,
}: CreateSupplierDrawerProps) => {
  return (
    <Drawer anchor={'right'} open={open} onClose={onClose}>
      <SideDrawerContainer>
        <Header>
          <Typography variant="h5">{'Create Supplier'}</Typography>
        </Header>
        <SupplierForm 
          handleClose={onClose} 
          onSupplierCreated={onSupplierCreated}
          createFromPurchaseOrderView={true}
        />
      </SideDrawerContainer>
    </Drawer>
  );
};

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px',
  height: '64px',
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const SideDrawerContainer = styled('div')(({ theme }) => ({
  width: '100vw',
  position: 'relative',
  height: '100%',
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.up('lg')]: {
    width: '500px',
  },
}));
